module.exports = JSON.parse("{\"timestamp\":\"19.10.2026 - 09:39:08\",\"brands\":[]}")